import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import styles from "./ComparativeAnalysis.module.css";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import Card from "@/components/common/card/Card";
import Tabs from "@/components/common/tab/Tab";
import { useComparativeChart } from "./useComparativeChart";
import { chartColors } from "@/utils/chartConfig";
import type {
    comparativeAnalysisProps,
    comparativeFilterKey,
} from "../types.props";
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);

const ComparativeAnalysisCard: React.FC<comparativeAnalysisProps> = ({
    tests,
    view = "vsInstitution",
    showTabs = true,
}) => {
    const [currentView, setCurrentView] = useState<comparativeFilterKey>(view);
    const { chartData, chartOptions } = useComparativeChart(tests, currentView);

    const tabItems = [
        { key: "vsInstitution", label: "vs. Institución" },
        { key: "vsGlobal", label: "vs. Global" },
    ];

    const headerActions = showTabs ? (
        <div className={styles["header-controls"]}>
            <Tabs
                items={tabItems}
                activeKey={currentView}
                onTabChange={(key) => setCurrentView(key as comparativeFilterKey)}
            />
        </div>
    ) : (
        false
    );

    return (
        <Card title="Análisis comparativo" icon="📈" headerActions={headerActions}>
            <div className={styles["chart-container"]}>
                <Bar data={chartData} options={chartOptions} />
            </div>
            <div className={styles["chart-legend"]}>
                <div className={styles["legend-item"]}>
                    <span
                        className={styles["legend-color"]}
                        style={{ backgroundColor: chartColors.primaryLight }}
                    />
                    Tu puntaje
                </div>
                <div className={styles["legend-item"]}>
                    <span
                        className={styles["legend-color"]}
                        style={{ backgroundColor: chartColors.secondaryLight }}
                    />
                    {currentView === "vsInstitution"
                        ? "Promedio institución"
                        : "Promedio global"}
                </div>
            </div>
        </Card>
    );
};

export default ComparativeAnalysisCard;
